const labelText = ({ label }) => label ? `${label} ` : ''

export const esConfig = {
  mixed: {
    default: (prm) => `${labelText(prm)} Es inválido`,
    required: '¡Este campo es requerido!',
    oneOf: (prm) =>
      `${labelText(prm)} Debe ser uno de los siguientes valores: ${prm.values}`,
    notOneOf: (prm) =>
      `${labelText(prm)} No debe ser uno de los siguientes valores: ${prm.values}`,
    notType: (prm) => {
      if (prm.type === 'number') {
        return `${labelText(prm)} Debe ser un número.`
      }
      if (prm.type === 'string') {
        return `${labelText(prm)} Debe ser una cadena de texto.`
      }
      if (prm.type === 'date') {
        return `${labelText(prm)} Debe ser una fecha válida.`
      }
      return `${labelText(prm)} Tiene un formato inválido.`
    }
  },
  string: {
    length: ({ length }) => `Ingrese ${length} caracter(es).`,
    min: ({ min }) => `Ingrese min. ${min} caracter(es).`,
    max: ({ max }) => `Límite max. ${max} caracter(es).`,
    matches: (prm) => `Ingrese ${labelText(prm)} en un formato válido.`,
    email: 'Correo inválido.',
    url: (prm) => `${labelText(prm)} Debe ser una URL válida.`,
    uuid: (prm) => `${labelText(prm)} Debe ser un UUID válido.`,
    trim: (prm) => `${labelText(prm)} No debe tener espacios al inicio o final.`,
  },
  number: {
    min: (prm) => `${labelText(prm)} Debe ser mínimo ${prm.min}.`,
    max: (prm) => `${labelText(prm)} Debe ser máximo ${prm.max}.`,
    lessThan: (prm) => `${labelText(prm)} Debe ser menor que ${prm.less}.`,
    moreThan: (prm) => `${labelText(prm)} Debe ser mayor que ${prm.more}.`,
    positive: (prm) => `${labelText(prm)} Debe ser número positivo.`,
    negative: (prm) => `${labelText(prm)} Debe ser número negativo.`,
    integer: (prm) => `${labelText(prm)} Debe ser número entero.`,
    maxDecimals: ({ label, maxDecimals }) =>
      `${labelText({
        label,
      })} Debe tener máximo ${maxDecimals} decimales.`,
  },
  date: {
    min: (prm) => `${labelText(prm)} Debe ser una fecha posterior a ${prm.min}.`,
    max: (prm) => `${labelText(prm)} Debe ser una fecha anterior a ${prm.min}.`
  },
  boolean: {
    isValue: (prm) => `${labelText(prm)} Requiere ser seleccionado.`
  },
  array: {
    length: (prm) => `${prm.length} ${labelText(prm)} son requeridos.`,
    min: (prm) => `${labelText(prm)} Debe tener al menos ${prm.min} elementos.`,
    max: (prm) => `${labelText(prm)} No debe contener más de ${prm.max} elementos.`
  }
}